import React, { Component } from 'react'
import { connect } from 'react-redux'
import Tooltip from './Tooltip'
import IconButton from '@material-ui/core/IconButton'
import MultiSelectIcon from '@material-ui/icons/ControlPoint'
import MapActions from '../redux/mapRedux'

class AddFeatureToMap extends Component {
  render () {
    const { addFeature, actions } = this.props

    return (
      <Tooltip id={'addFeatureToMap'} title={'add data to map'}>
        <IconButton
          onClick={actions.addFeatureToggled}
          color={addFeature ? 'inherit' : 'default'}
          >
          <MultiSelectIcon />
        </IconButton>
      </Tooltip>
    )
  }
}

const mapStateToProps = state => {
  return {
    addFeature: state.map.addFeature
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      addFeatureToggled: () => dispatch(MapActions.addFeatureToggled()),
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFeatureToMap)



// WEBPACK FOOTER //
// ./src/components/AddFeatureToMap.js